<div *ngFor="let alert of alerts" class="{{ cssClass(alert) }}">
  <button class="btn-close" (click)="removeAlert(alert)" aria-label="close alert"></button>
  <span [innerHTML]="alert.message"></span>
  <br />
  <button class="btn btn-danger" *ngIf="route" (click)="routeTo(route)">
    Back
  </button>
</div>

<style>
  .close:hover {
    cursor: pointer;
  }
</style>
